export enum SETTINGS_KEYS {
  AUTH0_TOKEN = "AUTH0_TOKEN",
  USER_PROFILE = "USER_PROFILE",
  ORGANIZATIONS = "ORGANIZATIONS",
}

export type SETTINGS_KEY = keyof typeof SETTINGS_KEYS;
